import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import Zoom from '@mui/material/Zoom';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import MediaSlider from './MediaSlider';
import { Typography } from '@mui/material';
import { DocumentEditor } from "@onlyoffice/document-editor-react";
import { API } from 'shared/constants/AppEnums';
import DocumentViewer from './DocumentViewer';


var onDocumentReady = function (event) {
  console.log(event, "Document is loaded");
};
var onLoadComponentError = function (errorCode, errorDescription) {
  switch (errorCode) {
    case -1: // Unknown error loading component
      console.log(errorDescription);
      break;

    case -2: // Error load DocsAPI from http://documentserver/
      console.log(errorDescription);
      break;

    case -3: // DocsAPI is not defined
      console.log(errorDescription);
      break;
  }
};

// docPreviewer 'ms = microsoft' 'oo= = onlyoffice'
const renderRow = (data, index, docPreviewer = 'ms') => {
  let url;
  let documentType = '';
  let fileType = data.name.split('.')[1]?.toLowerCase();
  if (docPreviewer === 'ms') {
    url =
      data.mime_type === 'docx' ||
        data.mime_type === 'doc' ||
        data.mime_type === 'application/doc' ||
        data.mime_type === 'application/docx' ||
        data.mime_type === 'application/msword' ||
        data.mime_type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        data.mime_type === 'ppt' ||
        data.mime_type === 'pptx' ||
        data.mime_type === 'application/pptx' ||
        data.mime_type === 'application/ppt' ||
        data.mime_type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
        data.mime_type === 'application/vnd.ms-powerpoint' ||
        data.mime_type === 'pot' ||
        data.mime_type === 'potm' ||
        data.mime_type === 'potx' ||
        data.mime_type === 'xls' ||
        data.mime_type === 'xlsx' ||
        data.mime_type === 'application/xlsx' ||
        data.mime_type === 'application/xls' ||
        data.mime_type === 'application/vnd.ms-excel' ||
        data.mime_type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ? `https://view.officeapps.live.com/op/view.aspx?src=${data.url}&wdOrigin=BROWSELINK` : data.url
  } else {
    url = data.url;
    if (data.mime_type === 'docx' ||
      data.mime_type === 'doc' ||
      data.mime_type === 'application/doc' ||
      data.mime_type === 'application/docx' ||
      data.mime_type === 'application/msword' ||
      data.mime_type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ) {
      documentType = 'word'
    } else if (data.mime_type === 'ppt' ||
      data.mime_type === 'pptx' ||
      data.mime_type === 'application/pptx' ||
      data.mime_type === 'application/ppt' ||
      data.mime_type === 'pot' ||
      data.mime_type === 'potm' ||
      data.mime_type === 'potx' ||
      data.mime_type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
      data.mime_type === 'application/vnd.ms-powerpoint'
    ) {
      documentType = 'slide'
    } else if (data.mime_type === 'xls' ||
      data.mime_type === 'xlsx' ||
      data.mime_type === 'application/xlsx' ||
      data.mime_type === 'application/xls' ||
      data.mime_type === 'application/vnd.ms-excel' ||
      data.mime_type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      documentType = 'cell'
    }
  }

  if (data.mime_type.startsWith('image')) {
    return (
      <img
        key={'IMAGE-' + index}
        src={url}
        alt={data.name ? data.name : 'detail view'}
      />
    );
  } else if (data.mime_type.startsWith('docs') || data.mime_type === 'pdf') {
    return (
      <Box className='embed-responsive'>
        {/* <iframe
          key={'DOC-' + index}
          src={url}
          title={data.name ? data.name : 'detail view'}
        /> */}
        <DocumentViewer url={url} />
      </Box>
    );
  } else {
    return (
      <Box className='embed-responsive' >
        {
          docPreviewer === 'ms' &&
          <iframe
            key={'DOC-' + index}
            src={url}
            title={data.name ? data.name : 'detail view'}
          />
        }
        {
          docPreviewer === 'oo' &&
          <DocumentEditor
            id="ooPreviewer"
            documentServerUrl={API.OO_DOC_SERVER}
            config={{
              "document": {
                "fileType": fileType,
                "key": data.id,
                "title": data.name,
                "url": url
              },
              "documentType": documentType,
              "editorConfig": {
                "mode": "view"
              },
            }}
            events_onDocumentReady={onDocumentReady}
            onLoadComponentError={onLoadComponentError}
          />
        }

      </Box>
    );
  }
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom in ref={ref} {...props} />;
});


const MediaViewer = ({ index, medias, onClose }) => {
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    if (index > -1) setOpen(true);
    else {
      setOpen(false);
    }
  }, [index]);

  return (
    <Dialog
      fullScreen
      open={isOpen}
      onClose={onClose}
      sx={{
        '& .MuiDialog-paperFullScreen': {
          display: 'flex',
          flexDirection: 'column',
        },
      }}
      TransitionComponent={Transition}
    >
      <Box
        sx={{
          position: 'relative',
          backgroundColor: 'rgb(49, 53, 65)',
          color: (theme) => theme.palette.common.white,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ paddingY: 4, paddingX: 5, display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 5 }}>
          <IconButton
            sx={{
              color: (theme) => theme.palette.common.white,
              zIndex: 1,
            }}
            onClick={onClose}
            size='large'
          >
            <HighlightOffIcon />
          </IconButton>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <Typography component={'span'}>{medias.name}</Typography>
            <Typography component={'span'}>{medias.size && medias.size}</Typography>
          </Box>
        </Box>

        {index >= 0 ? (
          <MediaSlider>
            <Slider
              dots={true}
              arrows={true}
              infinite={false}
              speed={300}
              slidesToShow={1}
              slidesToScroll={1}
              adaptiveHeight={false}
              slickGoTo={index}
              initialSlide={index}
            >
              {renderRow(medias, index)}
            </Slider>
          </MediaSlider>
        ) : null}
      </Box>
    </Dialog>
  );
};

export default MediaViewer;
MediaViewer.propTypes = {
  index: PropTypes.number,
  medias: PropTypes.object,
  onClose: PropTypes.func,
};
